import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchMe = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/google/me");
      setUser(data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchMe();
  }, [fetchMe]);

  const login = () => {
    const redirect = `${window.location.origin}/`;
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirect)}`;
  };

  const processSession = useCallback(async (sessionId) => {
    const { data } = await api.post("/auth/session", {}, { headers: { "X-Session-ID": sessionId } });
    setUser(data);
    return data;
  }, []);

  const logout = async () => {
    try {
      await api.post("/auth/google/logout");
    } catch (e) {}
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, logout, processSession, fetchMe }}>
      {children}
    </AuthCtx.Provider>
  );
};
